import { Image, ImageOverlay, ResultIcon } from 'ui';

import { PreviewGalleryImage } from '../../types';

export const PreviewImage = ({
  image,
  isPortrait,
  height = '100%',
}: {
  image: PreviewGalleryImage;
  isPortrait?: boolean;
  height?: string | number;
}) => {
  return (
    <ImageOverlay sx={{ height, position: 'relative', width: isPortrait ? 'auto' : '100%' }}>
      {image.status !== undefined ? (
        <ResultIcon
          variant={image.status}
          size="small"
          sx={{
            position: 'absolute',
            right: -8,
            top: -8,
          }}
        />
      ) : null}
      <Image src={image.src} sx={{ objectFit: 'contain' }} />
    </ImageOverlay>
  );
};
